import React from 'react';
import ReactDOM from 'react-dom';
import { VCardModal } from './VCardModal'; 

interface VCardModalWrapperProps {
    open: boolean;
    onClose: () => void;
    contactName: string;
    contactPhone: string;
}

export const VCardModalWrapper = ({ open, onClose, contactName, contactPhone }: VCardModalWrapperProps) => {
    if (!open) {
        return null;
    }

    return ReactDOM.createPortal(
        <VCardModal
            open={open}
            onClose={onClose}
            contactName={contactName}
            contactPhone={contactPhone}
        />,
        document.body 
    );
};